import { Box, Typography } from "@mui/material";
import { BudgetCastState, BudgetCastList } from "../components";

export const BudgetCastPerformance = () => {

    return (
        <Box py={2}>
            <Box display={'flex'} flexDirection={'column'} alignItems={'start'} px={2} mb={2}>
                <Typography variant="subtitle1" color="text.primary">Budget & Cost Performance</Typography>
                <Typography variant="caption" color="text.secondary">Detailed project-level budget, actuals, and forecast analysis</Typography>
            </Box>
            <BudgetCastState />
            <BudgetCastList />
        </Box>
    );

};